import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

const NoDelivery = ({ className }: Props) => {
    const { t } = useGranite();
    const { visibilityType, hasDelivery } = useECommerceProduct();

    if (hasDelivery) {
        return null;
    }

    return (
        <Button
            outline={true}
            color={"primary"}
            fullWidth={true}
            className={cn("tw:pointer-events-none", className)}
            disabled={true}
        >
            {t(`ecommerce.text.${visibilityType}`)}
        </Button>
    );
};

export { NoDelivery };
